module.exports = __webpack_public_path__ + "img/IT0001198963145.3034bb89.png";